/* eslint-disable */

import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import Image from "react-bootstrap/Image";
import { Link } from "react-router-dom";
import Logo from "../assets/images/Motivar.svg";

// Shared navbar shell used across the landing page, dashboards and other
// in-app pages: logo centered on desktop, left-aligned on mobile, with
// page-specific nav links / actions passed in as slots.
export default function SiteNavbar({
  brandTo = "/",
  leftNavDesktop = null,
  leftNavMobile = null,
  rightContent = null,
  // Match these to whatever <Container> the page body uses below the navbar,
  containerFluid = true,
  containerClassName = "px-md-5",
  style = {},
  hideOnScroll = false,
}) {
  const [isNavHidden, setIsNavHidden] = React.useState(false);
  const lastScrollY = React.useRef(0);

  React.useEffect(() => {
    if (!hideOnScroll) return;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Always show near the very top of the page
      if (currentScrollY <= 15) {
        setIsNavHidden(false);
      } else if (currentScrollY > lastScrollY.current && currentScrollY > 15) {
        // Scrolling down -> hide navbar to maximize screen space
        setIsNavHidden(true);
      } else if (currentScrollY < lastScrollY.current) {
        // Scrolling up -> reveal navbar
        setIsNavHidden(false);
      }
      lastScrollY.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [hideOnScroll]);

  const scrollStyles = hideOnScroll
    ? {
        transform: isNavHidden ? "translateY(-100%)" : "translateY(0)",
        opacity: isNavHidden ? 0 : 1,
        pointerEvents: isNavHidden ? "none" : "auto",
      }
    : {};

  return (
    <Navbar
      expand="lg"
      style={{
        backgroundColor: "rgba(255, 255, 255, 0.96)",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        borderBottom: "1px solid var(--color-border)",
        minHeight: "76px",
        height: "76px",
        zIndex: 500,
        transition: "transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease",
        ...scrollStyles,
        ...style,
      }}
      className="fixed-top shadow-xs"
    >
      <Container fluid={containerFluid} className={`${containerClassName} position-relative`}>
        {/* Left: Nav Links (Desktop) */}
        <Nav
          className="d-none d-lg-flex align-items-center"
          style={{ gap: "0.5rem", fontWeight: 600, fontSize: "0.95rem", margin: 0, padding: 0 }}
        >
          {leftNavDesktop}
        </Nav>

        {/* Center: Brand Logo (Desktop Centered) */}
        <Navbar.Brand
          as={Link}
          to={brandTo}
          className="position-absolute start-50 top-50 translate-middle d-none d-lg-flex align-items-center justify-content-center"
          style={{ left: "50%", top: "50%", transform: "translate(-50%, -50%)", margin: 0, padding: 0 }}
        >
          <Image src={Logo} alt="Motivar Logo" style={{ maxHeight: "36px", margin: 0 }} />
        </Navbar.Brand>

        {/* Mobile: Logo Left */}
        <Navbar.Brand as={Link} to={brandTo} className="d-flex d-lg-none align-items-center">
          <Image src={Logo} alt="Motivar Logo" style={{ maxHeight: "28px" }} />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar-nav" className="ms-auto border-0 shadow-none" />

        <Navbar.Collapse id="main-navbar-nav">
          {/* Mobile Nav Links */}
          <Nav
            className="d-lg-none align-items-start"
            style={{ gap: "0.75rem", fontWeight: 600, fontSize: "1rem", marginTop: "1rem", marginBottom: "1rem" }}
          >
            {leftNavMobile || leftNavDesktop}
          </Nav>

          {/* Right: Page-specific actions */}
          <div
            className="d-flex align-items-center ms-lg-auto flex-column flex-lg-row"
            style={{ gap: "0.75rem" }}
          >
            {rightContent}
          </div>
        </Navbar.Collapse>
      </Container>
      <style>
        {`
        .navbar .nav.d-lg-flex {
          display: flex !important;
          flex-direction: row !important;
          align-items: center !important;
          align-content: center !important;
          gap: 0.5rem !important;
        }
        .navbar .nav.d-lg-flex > .nav-link,
        .navbar .nav.d-lg-flex > .nav-item,
        .navbar .nav.d-lg-flex > .dropdown {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 !important;
          padding: 0 !important;
        }
        .navbar .nav.d-lg-flex .nav-link,
        .navbar .nav.d-lg-flex .dropdown-toggle {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          font-size: 0.95rem !important;
          font-weight: 600 !important;
          line-height: 1.2 !important;
          padding: 0.4rem 0.75rem !important;
          margin: 0 !important;
          vertical-align: baseline !important;
        }
        .navbar .nav.d-lg-flex .dropdown-toggle::after {
          display: inline-block !important;
          vertical-align: 0.15em !important;
          margin-left: 0.35em !important;
          margin-top: 0 !important;
          margin-bottom: 0 !important;
        }
        @media (max-width: 991.98px) {
          .navbar { min-height: 68px !important; height: auto !important; }
          .navbar-collapse { background: #ffffff; padding: 1.25rem; border-radius: 0 0 16px 16px; box-shadow: 0 12px 32px rgba(15, 23, 42, 0.1); }
          .navbar .d-lg-none.nav {
            flex-direction: column !important;
            align-items: flex-start !important;
          }
        }
        `}
      </style>
    </Navbar>
  );
}
